export default "__VITE_ASSET__Dkz2$1T0__"